import * as React from "react";
import { InputAdornment, TextFieldProps } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { useHubx } from "../../../HubX";
import uuidv4 from "../../../helpers/uuid";
import { EVENT_SEARCH_FIELD_CHANGE } from "../../../Events";
import SimpleTextField from "../../../components/SimpleTextField";

type SearchFieldProps = {
  eventId?: string;
  useCustomEvent?: boolean;
} & Omit<TextFieldProps, "value">;

function SearchField({ eventId, useCustomEvent = false, ...others }: SearchFieldProps) {
  const [value, setValue] = React.useState<string>("");
  const hub = useHubx();

  const handleChange = (e: React.ChangeEvent<{ value: string }>) => {
    const newValue = e.target.value;
    setValue(newValue);
    hub.notify(
      useCustomEvent && eventId ? eventId : EVENT_SEARCH_FIELD_CHANGE(eventId || uuidv4()),
      newValue
    );
  };

  return (
    <SimpleTextField
      autoComplete="off"
      value={value}
      onChange={handleChange}
      label="Buscar"
      id="filterSearch"
      variant="outlined"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      {...others}
    />
  );
}

export default SearchField;
